import React, { Component } from "react";
import FadeIn from "react-fade-in/lib/FadeIn";
import {
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Status,
  FormInput,
} from "ui-kit-ck-consultant";

import { getValue, months } from "../../../utils/general";
import { formatStat, roundStat } from "./statFormat";

import AuthContext from "../../../context/AuthContext";

const UNREPARABLE_LABELS = () => {
    return [
      {
        id: "nbFolders",
        name: "Nombre de dossiers",
        isCount: true,
      },
      {
        id: "ageVehicleGlobal",
        name: "Âge véhicule (m)",
      },
      {
        id: "VEI",
        name: "Taux de VEI",
      },
      {
        id: "missionSD29Global",
        name: "Délai mission-1er SD29 (j)",
      },
      {
        id: "mission2ndSD29Global",
        name: "Délai mission-2nd SD29 (j)",
      },
      {
        id: "SD29_2Global",
        name: "Délai SD29 n°1-n°2 (j)",
      },
      {
        id: "missionSD09Global",
        name: "Délai mission-SD09 (j)",
      },
      {
        id: "missionRetireGlobal",
        name: "Délai mission-demande enlèvement (j)",
      },
      {
        id: "missionVisitGlobal",
        name: "Délai mission – visite avant travaux (j)",
      },
      {
        id: "missionVisitRolling",
        name: "Délai mission – visite avant tvx - véhicule roulant (j)",
      },
      {
        id: "missionVisitNonRolling",
        name: "Délai mission – visite avant tvx - véhicule non roulant (j)",
      },
      {
        id: "missionSD29Rolling",
        name: "Délai mission-SD29 - véhicule roulant (j)",
      },
      {
        id: "missionSD29NonRolling",
        name: "Délai mission-SD29 - véhicule non roulant (j)",
      },
      {
        id: "missionClosingRolling",
        name: "Délai mission-dépôt - véhicule roulant (j)",
      },
      {
        id: "missionClosingNonRolling",
        name: "Délai mission-dépôt - véhicule non roulant (j)",
      },
      {
        id: "missionVisitWorkGlobal",
        name: "Mission - visite pendant travaux",
      },
      {
        id: "visitClosingGlobal",
        name: "Délai visite-dépôt (j)",
      },
      {
        id: "visitSD29Global",
        name: "Délai visite-SD29 (j)",
      },
      {
        id: "SD29ClosingGlobal",
        name: "Délai SD29-dépôt (j)",
      },
      {
        id: "missionDepotGlobal",
        name: "Délai mission-dépôt (j)",
      },
      {
        id: "VRADE",
        name: "Coût VRADE (€ TTC)",
      },
      {
        id: "vrade4600",
        name: "Dossiers (VRADE 0/4600 € TTC) (%)",
      },
      {
        id: "vrade4600Plus",
        name: "Dossiers (VRADE >=4600 € TTC) (%)",
      },
      {
        id: "vehicleTotalPriceDutyFree",
        name: "Prix à neuf avec options TTC",
      },
      {
        id: "averageMileage",
        name: "Kilométrage moyen",
      },
      {
        id: "correctiveRateTechnicalReport",
        name: "Taux de correctif selon marché HT dans bilan technique",
      },
      {
        id: "resultTechnicalReportDutyFree",
        name: "Taux de +/- values HT dans bilan technique",
      },
      {
        id: "countSignature",
        name: "Signatures électroniques lancées",
        isCount: true,
      },
      {
        id: "countSignatureOk",
        name: "Signatures électroniques validées",
        isCount: true,
      },
      {
        id: "rateSignatureOkSignature",
        name: "Taux de Signatures électroniques validées/lancées",
      },
      {
        id: "rateSignatureFolder",
        name: "Taux de signatures électroniques lancées/tous les dossiers",
      },
      {
        id: "rateSignatureOkFolder",
        name: "Taux de signatures électroniques validées/tous les dossiers",
      },
      {
        id: "notRunningVehicleRate",
        name: "Taux de non roulant (%)",
      },
      {
        id: "notRunningVehicleCount",
        name: "Nombre de non roulant",
        isCount: true,
      },
      {
        id: "nbVehicleWithAverageValue",
        name: "Nb de dossiers avec Valeur Moyenne à Neuf",
        isCount: true,
      },
    ];
  };

export const getUnreparableLabelsList = UNREPARABLE_LABELS;

export class TableUnreparable extends Component {
  getLabels = UNREPARABLE_LABELS;

  static contextType = AuthContext;

  getEvolution = (data1, data2, name) => {
    const inversedColorList = [
      "Délai mission-2nd SD29 (j)",
      "Délai mission – visite avant tvx - véhicule roulant (j)",
      "Délai mission – visite avant tvx - véhicule non roulant (j)",
      "Délai mission-SD29 - véhicule roulant (j)",
      "Délai mission-SD29 - véhicule non roulant (j)",
      "Délai mission-dépôt - véhicule roulant (j)",
      "Délai mission-dépôt - véhicule non roulant (j)",
      "Mission - visite pendant travaux",
      "Prix à neuf avec options TTC",
      "Taux de correctif selon marché HT dans bilan technique",
      "Taux de non roulant (%)",
      "Taux de VEI",
      "Délai mission-1er SD29 (j)",
      "Délai visite-SD29 (j)",
      "Délai mission-dépôt (j)",
      "Coût VRADE (€ HT)",
      "Dossiers (VRADE >=4600 € HT) (%)",
      "Délai SD29 n°1-n°2 (j)",
      "Délai mission-SD09 (j)",
      "Délai visite-dépôt (j)",
      "Délai SD29-dépôt (j)",
      "Délai mission – visite avant travaux (j)",
      "Coût VRADE (€ TTC)",
      "Dossiers (VRADE >=4600 € TTC) (%)",
      "Prix à neuf avec options HT",
    ];

    if (data1 && data2) {
      const value = roundStat((data2 / data1) * 100 - 100);
      if (inversedColorList.includes(name)) {
        if (value > 0) {
          return (
            <Status
              className="bg-red-light black w-100 nowrap"
              text={`${getValue(value)} %`}
            />
          );
        } else if (value < 0) {
          return (
            <Status
              className="bg-green-light black w-100 nowrap"
              text={`${getValue(value)} %`}
            />
          );
        } else {
          return <Status className="bg-blue-light black w-100" text="0,00 %" />;
        }
      } else {
        if (value > 0) {
          return (
            <Status
              className="bg-green-light black w-100 nowrap"
              text={`${getValue(value)} %`}
            />
          );
        } else if (value < 0) {
          return (
            <Status
              className="bg-red-light black w-100 nowrap"
              text={`${getValue(value)} %`}
            />
          );
        } else {
          return <Status className="bg-blue-light black w-100" text="0,00 %" />;
        }
      }
    } else {
      return <Status className="bg-blue-light black w-100" />;
    }
  };

  getCell = (idx, row) =>
    this.props.data[idx]
      ? formatStat(this.props.data[idx][row.id], row.isCount)
      : null;

  render() {
    return (
      <FadeIn className={"overflow-x-auto"}>
        <Table>
          <Thead>
            <Tr>
              <Th hide></Th>
              <Th radiusTopLeft>Cible</Th>
              <Th>N-1</Th>
              <Th>N</Th>
              <Th spaceRight>N/N-1</Th>
              {months.map((month, idx) => (
                <Th key={idx} spaceLeft={idx === 0}>
                  {month}
                </Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {this.getLabels().map((row, idx) => {
              return (
                <Tr key={idx}>
                  <Th radiusTopLeft={idx === 0}>{row.name}</Th>
                  <Td style={{ padding: 0 }}>
                    {this.context.role === 1 ? (
                      <FormInput
                        type="number"
                        styleInput={{
                          border: "none",
                          padding: "0 10px",
                          fontSize: 12,
                          height: 36,
                          borderRadius: 0,
                        }}
                        style={{
                          width: "80px",
                        }}
                        value={
                          this.props.performanceAgency[
                            `NR${this.props.company || ""}_${row.id}`
                          ] || ""
                        }
                        onChange={(e) =>
                          this.props.updatePerformanceAgency(
                            `NR${this.props.company || ""}_${row.id}`,
                            e.target.value
                          )
                        }
                        onBlur={() => this.props.leaveUpdatePerformanceAgency()}
                      />
                    ) : (
                      this.props.performanceAgency[
                        `NR${this.props.company || ""}_${row.id}`
                      ] || ""
                    )}
                  </Td>
                  <Td>
                    {this.props.data[0][row.id]
                      ? formatStat(this.props.data[0][row.id], row.isCount)
                      : null}
                  </Td>
                  <Td>
                    {this.props.data[1][row.id]
                      ? formatStat(this.props.data[1][row.id], row.isCount)
                      : null}
                  </Td>
                  <Td spaceRight>
                    {this.getEvolution(
                      this.props.data[0][row.id],
                      this.props.data[1][row.id],
                      row.name
                    )}
                  </Td>
                  <Td spaceLeft>
                    {this.props.data[2][row.id]
                      ? formatStat(this.props.data[2][row.id], row.isCount)
                      : null}
                  </Td>
                  <Td>
                    {this.getCell(3, row)}
                  </Td>
                  <Td>
                    {this.getCell(4, row)}
                  </Td>
                  <Td>
                    {this.getCell(5, row)}
                  </Td>
                  <Td>
                    {this.getCell(6, row)}
                  </Td>
                  <Td>
                    {this.getCell(7, row)}
                  </Td>
                  <Td>
                    {this.getCell(8, row)}
                  </Td>
                  <Td>
                    {this.getCell(9, row)}
                  </Td>
                  <Td>
                    {this.getCell(10, row)}
                  </Td>
                  <Td>
                    {this.getCell(11, row)}
                  </Td>
                  <Td>
                    {this.getCell(12, row)}
                  </Td>
                  <Td>
                    {this.getCell(13, row)}
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </FadeIn>
    );
  }
}

export default TableUnreparable;
